import { Dispatch } from "redux";
import { fetchCountries } from "../../services/countries/country";

import {
  getCountries as getCountriesAction,
  getCountriesSuccess,
  getCountriesError,
} from "../../store/ducks/countries";

export function getCountries() {
  return (dispatch: Dispatch) => {
    dispatch(getCountriesAction({ areCountriesLoading: true }));
    fetchCountries()
      .then(countries => {
        dispatch(getCountriesSuccess({ countries, areCountriesLoading: false }));
      })
      .catch(() => {
        dispatch(getCountriesError({ areCountriesLoading: false, hasErrorLoadingCountries: false }));
      });
  };
}
